// home.js
import React from 'react';
import config from '../../../../../config/config';
import CustomList from '../../Util/List/CustomList/CustomList';
import CustomListContainer from '../../Util/List/CustomList/CustomListContainer';
import { loadData } from '../../Util/List/CustomList/loadData';
import { useSelector } from 'react-redux';

import '../../home/Home.css';

const Property = () => {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });
    const friendly_url = sessionSelector.pdc_project_friendly_url;

    const paths = {
        endpoint: config.endpoints.backend + 'portal/getallproperties',
        endpointGetAllPropertyTypes: config.endpoints.backend + 'portal/getallpropertytypes'
    };

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_property_type_id',
                type: 'year',
                type: 'select',
                label: 'Tipo',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllPropertyTypes,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'year',
                type: 'year',
                selectable: true,
                label: 'Ano',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            }
        ]
    };

    const list = {
        labelTitle: 'Patrimônio',
        icon: 'fa-house',
        filter: {
            friendly_url
        },
        formFilters: filters,
        canDownload: true,
        fieldToDownload: 'file',
        columns: [
            {
                name: 'property_type',
                label: 'Tipo'
            },
            {
                name: 'demonstrative_period',
                label: 'Período'
            },
            {
                name: 'reference',
                label: 'Referência',
                width: "15%"
            },
            {
                name: 'description',
                label: 'Descrição'
            }
        ]
    };

    return (
        <div
            style={{
                marginLeft: '35px'
            }}
        >
            <CustomListContainer
                canAdd={false}
                labelTitle={list.labelTitle}
                icon={list.icon}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
};

export default Property;
